// extracted by mini-css-extract-plugin
export default {"slider":"category_slider__TDDfc","sliderItem":"category_sliderItem__b+CE3","width":"category_width__LvQ4t"};